import React from 'react';
import {StyleSheet, View} from 'react-native';

import SectionTitle from './SectionTitle';

export default function WebDesktopSection({children, title}) {
  return (
    <View style={styles.webDesktopContentSectionsWrapper}>
      <SectionTitle>{title}</SectionTitle>
      {children}
    </View>
  );
}

const styles = StyleSheet.create({
  webDesktopContentSectionsWrapper: {
    flex: '0.33',
  },
});
